module.exports = __webpack_public_path__ + "img/admin_assistant.f74a83d4.webp";